import { useState } from 'react'
import { Button, Icon } from '@opallabs/lapidary'
import { Modal } from '@opallabs/satellite'
import { StoryDuplicatorForm } from './Form'
import * as styles from './styles'
import { StoryDuplicatorModalProps } from './types'

export const StoryDuplicatorModal: React.FC<StoryDuplicatorModalProps> = ({
  brandId,
  brands,
  description,
  duplicatedFromStoryId,
  isModalVisible,
  name,
  onClose,
  onSubmit,
  scheduledEndAt,
  scheduledStartAt,
}) => {
  const [modalVisible, setModalVisible] = useState<boolean>(
    isModalVisible || false
  )

  const closeModal = () => {
    setModalVisible(false)
    onClose()
  }

  return (
    <Modal
      backgroundColor={'rgba(24, 34, 41, 0.95)'}
      bodyStyleOverrides={styles.modalWrapper}
      key="story-duplicator-modal-container"
      onClose={closeModal}
      visible={modalVisible}
    >
      <Button
        ariaLabel="close"
        variant="ghost"
        css={styles.closeButton}
        icon={<Icon glyph="gem-close" ariaHidden />}
        onClick={closeModal}
        name="close"
        theme="dark"
      />

      <div css={styles.formWrapper}>
        <StoryDuplicatorForm
          brandId={brandId}
          brands={brands}
          description={description}
          duplicatedFromStoryId={duplicatedFromStoryId}
          name={name}
          onClose={closeModal}
          onSubmit={onSubmit}
          scheduledEndAt={scheduledEndAt}
          scheduledStartAt={scheduledStartAt}
        />
      </div>
    </Modal>
  )
}
